import { useMutation, useQueryClient } from "@tanstack/react-query";
import { IFeedbackApi } from "@/api/feedback";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { Feedback, UpdateFeedbackPayload } from "@/models/feedback";
import { useToast } from "@/hooks/use-toast";

interface UpdateFeedbackArgs {
  id: string;
  payload: UpdateFeedbackPayload;
}

export const useUpdateFeedback = () => {
  const feedbackApi = useInjection<IFeedbackApi>(SERVICES_TYPES.FEEDBACK);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateFeedbackArgs) => feedbackApi.update(id, payload),
    onSuccess: (updated) => {
      // Write the returned item straight into the cache so the row updates
      // immediately, instead of waiting on a full list refetch.
      queryClient.setQueryData<Feedback[]>(["feedback"], (current) =>
        current?.map((item) => (item._id === updated._id ? updated : item))
      );
      toast({ title: "Feedback updated" });
    },
    onError: (error) => {
      toast({
        title: "Failed to update feedback",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
